import { inject, Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
import { Cacheable }      from '../../shared/utils/cache.utils';
import { mergeMap }       from 'rxjs/operators';

import { environment }          from '../../../environments/environment';
import { RestService }          from '../../core/rest.service';
import { StringUtils }          from '../../shared/utils/string.utils';
import { ListItem }             from '../ListItem';
import { SessionService }       from '../session/session.service';
import { TaxDocuments }         from './tax-documents';
import { DocumentsHelperUtils } from '../../shared/utils/documents-helper.utils';

@Injectable({
  providedIn: 'root'
})
export class TaxDocumentsService {
  private restService = inject(RestService);
  private sessionService = inject(SessionService);

  @Cacheable(
    {
      cacheKey: 'taxDocumentsList'
    }
  )
  getTaxDocumentsList(customerId: number, taxYear: number): Observable<TaxDocuments> {
    const apiEndpoint = StringUtils.format(environment.api.endpoints.taxDocumentsList, customerId, taxYear);
    return this.restService.get(apiEndpoint);
  }

  downloadTaxDocument(customerId: number, taxYear: number, formId: string): Observable<BlobPart> {
    const options = {
      headers: {
        'Accept': 'application/pdf'
      },
      responseType: 'blob'
    };

    return this.restService.get(StringUtils.format(environment.api.endpoints.taxDocumentDownload, customerId, taxYear, formId), options);
  }

  @Cacheable({
    cacheKey: 'taxDocumentCustomers'
  })
  getTaxDocumentCustomers(): Observable<ListItem<number>[]> {
    return this.sessionService.loadSession().pipe(mergeMap(session => {
      if (DocumentsHelperUtils.showTaxDocuments(session)) {
        return this.restService.get<ListItem<number>[]>(environment.api.endpoints.taxDocumentCustomers);      }
      return of([]);
    }));
  }

  @Cacheable(
    {
      cacheKey: 'taxYears'
    }
  )
  getLatestTaxYear(): Observable<number> {
    return this.restService.get(environment.api.endpoints.taxDocumentsLatestTaxYear);
  }
}
